module.exports = __webpack_public_path__ + "static/media/400174_02.c44ca6d4.png";